<template>
  <Modal v-model="customizedPartsModal" :title="customizedPartsTitle" width="600"
    :transfer="false" :mask-closable="false" @on-visible-change="customizedPartsChange">
    <Form ref="customizedPartsForm" :model="customizedPartsForm" :label-width="100"
      @submit.native.prevent :disabled="customizedPartsType === 'look'">
      <Row>
        <languagesTabs ref="languagesTab" :tabsList="multilingualNamesList">
          <template v-for="item in multilingualNamesList">
            <template :slot="item.name">
              <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
                <Form-item :label="labelRander(item)" :prop="'parts_' + item.code" :rules="getRules(item)">
                  <Input clearable :maxlength="20" v-model.trim="customizedPartsForm['parts_' + item.code]" class="width_400"></Input>
                </Form-item>
              </Col>
            </template>
          </template>
        </languagesTabs>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1003540')" prop="status" class="radio_styles">
            <RadioGroup v-model="customizedPartsForm.status">
              <Radio :label="1">{{ $t('key1000462') }}</Radio>
              <Radio :label="0">{{ $t('key1000463') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <template v-if="customizedPartsType === 'look'">
        <Button @click="customizedPartsModal = false">{{ $t('key1000248') }}</Button>
      </template>
      <template v-else>
        <Button @click="customizedPartsModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="customizedPartsBtn">{{ $t('key1000111') }}</Button>
      </template>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import languagesTabs from "@/components/common/languagesTabs.vue";

export default {
  name: 'customizedPartsModal',
  components: {languagesTabs},
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      customizedPartsModal: false,
      customizedPartsTitle: '',
      customizedPartsType: null,
      customizedPartsForm: {
        status: 1
      },
      labelRander: (params) => {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003290') + params.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002424');
      },
      ymsProductCategoryPositionId: null,
      currentIndex: 0,
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initCustomizedPartsData(type, data, currentIndex) {
      this.initMultilingualFields('customizedPartsForm', this.customizedPartsForm, ['parts_']).then(() => {
        let obj = {
          add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003533'),
          edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003538'),
          look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003539'),
        };
        if (type !== 'add') {
          this.ymsProductCategoryPositionId = data.ymsProductCategoryPositionId;
          this.currentIndex = currentIndex;
          let vals = this.handleMultilingualFormFields(data, ['parts']);
          this.customizedPartsForm = Object.assign({}, vals, {status: data.status});
        }
        this.customizedPartsType = type;
        this.customizedPartsTitle = obj[type];
        this.customizedPartsModal = true;
      });
    },
    // 确定按钮
    customizedPartsBtn() {
      let v = this;
      let obj = {
        parts: v.handleMultilingualSingleParam(v.customizedPartsForm, 'parts_'),
        status: v.customizedPartsForm.status,
        createdBy: v.userInfo.userId,
        customizedPartsType: v.customizedPartsType
      };
      if (v.customizedPartsType === 'edit') {
        obj.ymsProductCategoryPositionId = v.ymsProductCategoryPositionId;
        obj.currentIndex = v.currentIndex;
      }
      v.$refs['customizedPartsForm'].validate((valid) => {
        if (valid) {
          v.customizedPartsModal = false;
          v.$emit('updateCustomizedParts', obj);
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000364'));
          return false;
        }
      });
    },
    // 监听弹窗
    customizedPartsChange(value) {
      if (!value) {
        this.$refs['customizedPartsForm'].resetFields();
        this.customizedPartsType = 'add';
        this.distributorsTitle = '';
        this.ymsProductCategoryPositionId = null;
        this.currentIndex = null;
      } else {
        this.$nextTick(() => {
          this.$refs['languagesTab'].tabName = this.languagesVal;
        });
      }
    },
    // 设置表单必填项校验规则
    getRules(item) {
      let list = [];
      if (item.required) {
        list = [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003290') + item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002427'), trigger: 'blur'}
        ];
      }
      return list;
    },
  }
};
</script>

<style lang="less">

</style>
